// mantine
import { UnstyledButton } from '@mantine/core';
// icons
import { Trash2 } from 'lucide-react';
// utils
import { formatFileSize } from '@newo/toolkit/file';

interface FileItemProps {
    name: string;
    size: number;
    onDelete: () => void;
}

const FileItem = ({ name, size, onDelete }: FileItemProps) => {
    return (
        <div className="flex items-center p-4 rounded-lg bg-gray-0">
            <div>
                <span className="text-sm">{name}</span>{' '}
                <span className="text-xs text-gray-8">
                    ({formatFileSize(size)})
                </span>
            </div>
            <UnstyledButton
                className="ml-auto text-red-6"
                title="Delete"
                onClick={onDelete}
            >
                <Trash2 />
            </UnstyledButton>
        </div>
    );
};

export default FileItem;
